import { AlertFilled, CheckCircleFilled, ClockCircleFilled, MinusCircleFilled } from '@ant-design/icons';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import PlayCircleOutlineOutlinedIcon from '@mui/icons-material/PlayCircleOutlineOutlined';
import StopCircleOutlinedIcon from '@mui/icons-material/StopCircleOutlined';
import {
    Button,
    DatePicker,
    Input,
    Modal,
    notification,
    Popconfirm,
    Progress,
    Radio,
    Select,
    Table,
    Tooltip
} from "antd";
import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../styles/LeaveTabStyle.css";
import Constants from "../../utils/Constants";
import ShowMessage from "../common/alert/ShowMessage";
import DisplayName from "../common/DisplayName";

const {Option} = Select;
const {TextArea} = Input;
const {RangePicker} = DatePicker;

const LeaveTabLayout = ({archieved}) => {
    const [api, contextHolder] = notification.useNotification();
    const navigate = useNavigate();
    const [dataSource, setDataSource] = useState([]);
    const [stat, setStat] = useState([]);
    const [leaveApplications, setLeaveApplications] = useState([]);
    const [leaveDataSource, setLeaveDataSource] = useState();
    const [error, setError] = useState(null);
    const [halfDaySelection, setHalfDaySelection] = useState(false);
    const [defaultSelection, setDefaultSelection] = useState(1);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [weeklyModalVisible, setWeeklyModalVisible] = useState(false);
    const [showMessage, setShowMessage] = useState(false);
    const [warningMessage, setWarningMessage] = useState("");
    const [leaveFormData, setLeaveFormData] = useState({
        leave_type_id: "",
        leave_from: "",
        leave_to: "",
        length: 1,
        leave_reason: "",
    });
    const [searchText, setSearchText] = useState("");
    const [orderBy, setOrderBy] = useState("");
    const [applicationStatus, setApplicationStatus] = useState("");
    const [page, setPage] = useState(1);
    const [totalPage, setTotalPage] = useState(1);
    const [leaveQuotes, setLeaveQuotes] = useState("");
    const [mealTypesForCancelation, setMealTypesForCancelation] = useState(Constants.MEAL_TYPE.FULL);

    const [statusArray, setStatusArray] = useState([]);
    const [tableParams, setTableParams] = useState({
        pagination: {
            current: 1,
            pageSize: 8
        },
    });

    const [todayLeave, setTodayLeave] = useState([]);
    const [weeklyData, setWeeklyData] = useState([]);
    const base_url = process.env.REACT_APP_BASE_URL;
    const clColor = {'0%': '#108ee9', '100%': '#108ee9'};
    const slColor = {'0%': '#87d068', '100%': '#87d068'};
    const rlColor = {'0%': '#C1482a', '100%': '#C1482a'};
    const LEAVE_QUOTES = Constants.LEAVE_QUOTES;

    const openNotificationWithIcon = (type, message, description) => {
        api[type]({
            message,
            description,
            duration: 3
        });
    };

    const getLeaveProgressColor = (shortCode) => {
        if (shortCode === "CL") {
            return clColor;
        } else if (shortCode === "SL") {
            return slColor;
        } else {
            return rlColor;
        }
    }

    const fetchLeaveAllocations = async () => {
        try {
            const accessToken = sessionStorage.getItem("accessToken");
            const response = await axios.get(
                `${base_url}/api/v1/client/leave/allocations`,
                {
                    headers: {Authorization: `Bearer ${accessToken}`},
                }
            );

            const leaveAllocations = response.data.data;
            const newData = response.data.data.map((item) => ({
                leave_type_id: item.leave_type_id,
                leave_type_name: item.leave_type_name,
                allocation_year: item.allocation_year,
                short_code: item.short_code,
                percentage: item.percentage,
                total_allocated_leaves_for_allocation_year:
                item.total_allocated_leaves_for_allocation_year,
                total_remaining_leaves_for_allocation_year:
                item.total_remaining_leaves_for_allocation_year,
            }));

            setDataSource(newData);
            setLeaveDataSource(leaveAllocations);
            if (leaveAllocations && leaveAllocations.length > 0) {
                setLeaveFormData({...leaveFormData, 'leave_type_id': leaveAllocations[0].leave_type_id});
            }
        } catch (error) {
            console.error("Error fetching leave allocations:", error);
        }
    };

    const fetchLeaveApplications = async () => {
        try {
            const accessToken = sessionStorage.getItem("accessToken");
            let upcoming = archieved === 0 ? 1 : 0;
            let apiUrl = `${base_url}/api/v1/client/leave/applications`;
            let params = [];
            params.push(`search_text=${searchText}`);
            params.push(`order_by=${orderBy}`);
            params.push(`application_status=${applicationStatus}`);
            params.push(`upcoming=${upcoming}`);
            params.push(`page=${page}`);

            let actualUrl = apiUrl + (params.length > 0 ? "?" + params.join("&") : "");

            const response = await axios.get(
                actualUrl,
                {
                    headers: {Authorization: `Bearer ${accessToken}`},
                }
            );

            const status = response.data.data.map((data) => ({
                currentStatus: data.current_status.map((status) => ({
                    managerName: status.manager_name,
                    status: status.status,
                    comment: status.comment,
                }))
            }));
            setStatusArray(status);
            setLeaveApplications(response.data.data);
            setTotalPage(response.data.totalPages);
            setTableParams({
                pagination: {
                    current: page,
                    pageSize: 8,
                    total: response.data.totalLeaveApplications
                },
            });
            setStat(response.data.statistics);
        } catch (error) {
            console.error("Error fetching leave allocations:", error);
        }
    };

    const deleteLeaveApplications = async (applicationId) => {
        try {
            const accessToken = sessionStorage.getItem("accessToken");
            let apiUrl = `${base_url}/api/v1/client/leave/applications/delete/${applicationId}`;

            await axios.delete(
                apiUrl,
                {
                    headers: {Authorization: `Bearer ${accessToken}`},
                }
            );
            fetchLeaveApplications()
            openNotificationWithIcon('success', 'SUCCESS', 'Leave application delete success');
        } catch (error) {
            console.error("Error fetching leave allocations:", error);
        }
    };

    useEffect(() => {
        fetchLeaveAllocations();
        getLeaveApplicationWeeklySummary();
    }, []);

    useEffect(() => {
        fetchLeaveApplications();
    }, [page])

    const showModal = () => {
        if (dataSource.length === 0) {
            setWarningMessage("You don't have any leave allocation. Please contact Admin");
            setShowMessage(true);
        } else {
            setIsModalVisible(true);
            setLeaveQuotes(LEAVE_QUOTES[Math.floor(Math.random() * LEAVE_QUOTES.length)]);
        }
    };

    const navigateArchivePage = () => {
        navigate('/archive-leaves')
    };

    const handleCancel = () => {
        setWarningMessage("")
        setIsModalVisible(false);
        setLeaveQuotes("");
        setMealTypesForCancelation(Constants.MEAL_TYPE.FULL);
    };

    const handleCancelWithWarning = (message) => {

        setWarningMessage(message);
        setShowMessage(true);

    };

    const handleInputChange = (e) => {
        const {id, value} = e.target;
        setLeaveFormData({...leaveFormData, [id]: value});
    };

    const handleMealCancelation = (value) => {

        if (value === "all") {
            setMealTypesForCancelation(Constants.MEAL_TYPE.FULL);
        }
        if (value === "breakfast") {
            setMealTypesForCancelation(Constants.MEAL_TYPE.BREAKFAST);
        }
        if (value === "lunch") {
            setMealTypesForCancelation(Constants.MEAL_TYPE.LUNCH);
        }
        if (value === "none") {
            setMealTypesForCancelation(Constants.MEAL_TYPE.NONE);
        }
    };

    const getLeaveApplicationWeeklySummary = async () => {
        const accessToken = sessionStorage.getItem("accessToken");
        let response = await axios.get(
            `${base_url}/api/v1/client/leave/applications/weekly/summary`,
            {
                headers: {Authorization: `Bearer ${accessToken}`},
            }
        );
        let {data} = response.data
        setTodayLeave(data[moment().format("YYYY-MM-DD")])
        setWeeklyData(formatData(data))
    }

    const formatData = (records) => {
        return Object.keys(records).map(item => {
            let record = records[item]
            return {
                key: item,
                date: <div style={{display: "flex", flexDirection: "column"}}>
                    <span>{item}</span>
                    <span>{moment(item).format("dddd")}</span>
                </div>,
                count: record.length,
                description: <div
                    style={{display: "flex", flexDirection: "column", marginBottom: "20px", fontSize: "12px"}}>
                    {record.map(i => (<DisplayName key={i.emp_code} item={i}/>))}
                </div>
            }
        })
    }

    const handleAddLeave = async () => {
        try {

            const accessToken = sessionStorage.getItem("accessToken");
            const user_id = sessionStorage.getItem("userData");
            const reporting_manager = sessionStorage.getItem("reporting_manager");
            if (!reporting_manager || reporting_manager === 'null') {
                setWarningMessage("You don't have any reporting manager associated. Please contact admin")
                setShowMessage(true)
                return;
            }

            if (!leaveFormData.leave_type_id) {
                setError("Please select a leave type");
                return;
            }

            if (!leaveFormData.leave_from) {
                setError("Please select the leave start date");
                return;
            }

            if (!leaveFormData.leave_to) {
                setError("Please select the leave end date");
                return;
            }

            if (!leaveFormData.length) {
                setError("Please specify the leave length");
                return;
            }

            if (!leaveFormData.leave_reason) {
                setError("Please provide a leave reason");
                return;
            }

            setError(null);

            // set meal cancelation for whole day for braekfast or lunch
            leaveFormData['cancel_meal_type'] = mealTypesForCancelation;

            let response = await axios.post(
                `${base_url}/api/v1/client/leave/applications/create`,
                leaveFormData,
                {
                    headers: {Authorization: `Bearer ${accessToken}`},
                }
            );

            if (response) {

                if (response?.data?.leaveAvailable === true) {

                    openNotificationWithIcon('success', 'SUCCESS', 'Leave application create success');
                    fetchLeaveApplications();
                    setLeaveFormData({
                        leave_type_id: "",
                        leave_from: "",
                        leave_to: "",
                        length: 1,
                        leave_reason: "",
                    });

                    handleCancel();

                } else {
                    openNotificationWithIcon('error', 'ERROR', 'Leave application failed');
                    handleCancelWithWarning(response?.data?.msg);
                }
            } else {
                openNotificationWithIcon('error', 'ERROR', 'Leave application failed');
            }

        } catch (error) {

            console.error("Error adding leave:", error);

        }
    };

    let columns = [
        {
            title: "Applicant",
            dataIndex: "leave_type_name",
            render: (_, record) => (
                <div style={{display: "flex", flexDirection: "column", whiteSpace: "nowrap"}}>
                    {/* <div>
                        <div style={{fontSize: "12px"}} dangerouslySetInnerHTML={{__html: `<b>${record.appliedFor}</b>`}}></div>
                    </div> */}
                    <div>
                        <div style={{fontSize: "12px"}}
                             dangerouslySetInnerHTML={{__html: `Asked for a <b>${record.leave_type_name}</b>`}}></div>
                    </div>
                </div>
            )
        },
        {
            title: "Reason",
            dataIndex: "leave_reason",
            render: (_, record) => (
                <div style={{display: "flex", flexDirection: "column"}}>
                    <div style={{fontSize: "12px"}} dangerouslySetInnerHTML={{__html: `${record.leave_reason}`}}></div>
                </div>
            )
        },
        {
            title: "Details",
            dataIndex: "leave_length",
            render: (_, record) => (
                <div style={{display: "flex", flexDirection: "column", whiteSpace: "nowrap"}}>
                    <div>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                        }}>
                            <PlayCircleOutlineOutlinedIcon style={{fontSize: "medium", color: "green"}}/>
                            <span
                                style={{paddingLeft: "5px"}}> <b>{record.leave_from} ( {record.leave_from_day} )</b></span>
                        </div>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                        }}>
                            <StopCircleOutlinedIcon style={{fontSize: "medium", color: "red"}}/>
                            <span
                                style={{paddingLeft: "5px"}}> <b>{record.leave_to} ( {record.leave_to_day} )</b></span>
                        </div>
                    </div>
                    {record.total_requested_days_including_holidays !== record.total_requested_days_excluding_holidays ? (
                        <>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                            }}>
                                <InfoOutlinedIcon style={{fontSize: "medium", color: "#6b9f6b"}}/>
                                <span
                                    style={{paddingLeft: "5px"}}> <b>{record.total_requested_days_including_holidays} days</b> including holidays</span>
                            </div>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                            }}>
                                <InfoOutlinedIcon style={{fontSize: "medium", color: "#6b9f6b"}}/>
                                <span
                                    style={{paddingLeft: "5px"}}> <b>{record.total_requested_days_excluding_holidays} days</b> excluding holidays</span>
                            </div>
                        </>
                    ) : (
                        <>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                            }}>
                                <InfoOutlinedIcon style={{fontSize: "medium"}}/>
                                <span style={{paddingLeft: "5px"}}>{record.leave_length === 1 ? (<>
                                    <b>{record.leave_length}</b></>) : (<><b>{record.leave_length}</b> Only</>)}</span>
                            </div>
                        </>
                    )}
                </div>
            )
        },
        {
            title: "Status",
            dataIndex: "final_status",
            render: (_, record) => (
                <div style={getStatusBadge(record.final_status)}
                     className="application-status" dangerouslySetInnerHTML={{__html: `${record.final_status}`}}></div>
            )
        },
        {
            title: "Approvals",
            dataIndex: "current_status",
            render: (_, record) => (
                <div style={{display: "flex", flexDirection: "column"}}>
                    {record.current_status && record.current_status.length > 0 ? (
                        <div className="list-item-col">
                            {record.current_status.map((i, index) => (
                                <div className="table-item-row item-padding" key={index}>
                                    <div style={{display: "flex", flexDirection: "row"}}>
                                        <div style={{
                                            width: "20px",
                                            textAlign: "center"
                                        }}>{`${index + 1}.`}</div>
                                        <div style={{width: "150px"}}>{`${i.manager_name}`}</div>
                                        <div style={{width: "100px"}}>
                                            <div style={getStatusBadge(i.status)}
                                                 className="user-status">{`${i.status}`}</div>
                                        </div>
                                    </div>
                                    <div style={{
                                        marginLeft: "20px",
                                        fontSize: "12px"
                                    }}>{`${i.comment === '' ? 'Waiting for feedback' : i.comment}`}</div>
                                </div>
                            ))}
                        </div>
                    ) : ""
                    }
                </div>
            )
        },
        {
            title: "Action",
            dataIndex: "action",
            hidden: true,
            render: (_, record) => (
                <div>
                    {record.final_status === 'Pending' ? (
                        <Popconfirm
                            title="Warning"
                            description="Are you sure want to cancel?"
                            onConfirm={() => onDeleteApplication(record.leave_application_id)}
                            onCancel={() => {
                            }}
                            okText="Yes"
                            cancelText="No"
                        >
                            <div className="action-btn delete-btn">Cancel</div>
                        </Popconfirm>
                    ) : ""}
                </div>
            )
        }
    ];

    if (archieved === 1) {
        columns = columns.filter(item => !item.hidden);
    }

    function getLeaveTextColor(shortCode) {
        if (shortCode === "CL") {
            return {color: "#108ee9", fontSize: "18px", wordWrap: "break-word", padding: "0px 5px"};
        } else if (shortCode === "SL") {
            return {color: "#87d068", fontSize: "18px", wordWrap: "break-word", padding: "0px 5px"};
        } else {
            return {color: "#C1482a", fontSize: "18px", wordWrap: "break-word", padding: "0px 5px"};
        }
    }

    function getStatusBadge(status) {
        if (status === "Pending") {
            return {background: "#FFC300"};
        } else if (status === "Approved") {
            return {background: "#87d068"};
        } else if (status === "Rejected") {
            return {background: "#C70039", color: "#FFFFFF"};
        }
    }

    const onRangeSet = (value) => {
        if (value?.length > 0) {
            let startDate = value[0].format("YYYY-MM-DD");
            let endDate = value[1].format("YYYY-MM-DD");
            let object = {...leaveFormData, 'leave_from': startDate, 'leave_to': endDate}
            if (startDate !== endDate) {
                object.length = 1
            }
            setLeaveFormData(object);
        }
    }

    useEffect(() => {
        if (leaveFormData.leave_to && leaveFormData.leave_from && leaveFormData.leave_to === leaveFormData.leave_from) {
            setHalfDaySelection(true)
        } else {
            setHalfDaySelection(false)
        }
    }, [leaveFormData])

    const onPageChange = (selectedPage) => {
        setPage(selectedPage.current)
        setTableParams({
            selectedPage
        });
    }

    const onDeleteApplication = (applicationId) => {
        deleteLeaveApplications(applicationId)
    }

    function onWarningClick() {
        setShowMessage(false)
    }

    function getStatusColor(item) {
        return item.final_status === 'Pending' ? 'orange' : 'green'
    }

    const onWeeklyModalClose = () => {
        setWeeklyModalVisible(false)
    }

    const weeklyColumns = [
        {
            title: 'Date',
            dataIndex: 'date',
            key: 'date',
        },
        {
            title: 'Count(s)',
            dataIndex: 'count',
            key: 'count',
        }
    ];

    return (
        <>
            <div className="leave-container">
                {contextHolder}
                <div className="summary-info" onClick={() => setWeeklyModalVisible(true)}>
                    <div style={{fontWeight: "bold", marginRight: "5px"}}>Today in Leave:</div>
                    {todayLeave && todayLeave.length > 0 ? (<div>
                        {todayLeave.map(item => (<DisplayName key={item.emp_code} item={item}/>))}
                    </div>) : (<div style={{marginRight: "5px"}}>Nobody has taken leave</div>)}
                </div>
                {archieved === 0 ? (
                    <div style={{display: "flex", flexDirection: "column"}} className='leave-info'>
                        <h3>Leave Balance</h3>
                        <div className="leave-balance-content">
                            <div className="dynamic-section">
                                {dataSource.length > 0 ? dataSource.map((item, index) => (
                                    <div className="dynamic-item" key={index}>
                                        <Progress type="circle" strokeColor={getLeaveProgressColor(item.short_code)}
                                                  size={[100, 100]} percent={item.percentage} format={(percent) => {
                                            return <div
                                                style={getLeaveTextColor(item.short_code)}>{`${item.total_remaining_leaves_for_allocation_year} Days Left`}</div>
                                        }}/>

                                        <Tooltip title={`Total Allocated ${item.leave_type_name}`}>
                                            <div>{`${item.short_code} - ${item.total_allocated_leaves_for_allocation_year}`}</div>
                                        </Tooltip>
                                    </div>
                                )) : (
                                    <div>Not Allocated</div>
                                )}
                            </div>
                            <div className="static-section">
                                <div className="card-section">
                                    <AlertFilled style={{color: "hotpink", marginRight: "10px"}}/>
                                    <div style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
                                        <div style={{fontSize: "26px", fontWeight: "bold"}}>{stat.total ?? 0}</div>
                                        <div style={{fontSize: "10px"}}>Requests</div>
                                    </div>
                                </div>
                                <div className="card-section">
                                    <CheckCircleFilled style={{color: "forestgreen", marginRight: "10px"}}/>
                                    <div style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
                                        <div style={{fontSize: "26px", fontWeight: "bold"}}>{stat.approved ?? 0}</div>
                                        <div style={{fontSize: "10px"}}>Approved</div>
                                    </div>
                                </div>
                                <div className="card-section">
                                    <ClockCircleFilled style={{color: "orange", marginRight: "10px"}}/>
                                    <div style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
                                        <div style={{fontSize: "26px", fontWeight: "bold"}}>{stat.pending ?? 0}</div>
                                        <div style={{fontSize: "10px"}}>Pending</div>
                                    </div>
                                </div>
                                <div className="card-section">
                                    <MinusCircleFilled style={{color: "indianred", marginRight: "10px"}}/>
                                    <div style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
                                        <div style={{fontSize: "26px", fontWeight: "bold"}}>{stat.rejected ?? 0}</div>
                                        <div style={{fontSize: "10px"}}>Rejected</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="leave-action-section">
                            <Button style={{marginRight: "20px"}} onClick={navigateArchivePage}>
                                Archived Leave
                            </Button>
                            <Button type="primary" onClick={showModal}>
                                Apply Leave
                            </Button>
                        </div>
                    </div>
                ) : <div className='leave-info'></div>}

                <ShowMessage title="Warning" message={warningMessage} show={showMessage} onClickOk={onWarningClick}/>
                <Modal
                    title={
                        <>
                            <div
                                style={{
                                    textAlign: "center",
                                    fontSize: "26px",
                                    fontWeight: "normal",
                                    marginBottom: "20px",
                                    color: "#00B0F0",
                                }}
                            >
                                we appreciate to take leave !
                            </div>
                            <div style={{
                                textAlign: "center",
                                fontSize: "14px",
                                marginBottom: "15px",
                                color: "#3a849f"
                            }}
                            >
                                “{leaveQuotes}”
                            </div>
                        </>
                    }
                    centered
                    open={isModalVisible}
                    onOk={handleAddLeave}
                    onCancel={handleCancel}
                    destroyOnClose={true}
                >
                    <div style={{marginBottom: "10px"}}>
                        <label htmlFor="leave_type_id" style={{marginBottom: "5px"}}>
                            Leave Type:
                        </label>
                        <Select
                            id="leave_type_id"
                            defaultValue={
                                leaveDataSource && leaveDataSource.length > 0
                                    ? leaveDataSource[0]?.leave_type_name
                                    : undefined
                            }
                            onChange={(value) =>
                                handleInputChange({target: {id: "leave_type_id", value}})
                            }
                            style={{width: "100%"}}
                            options={
                                leaveDataSource
                                    ? leaveDataSource.map((item) => ({
                                        label: item.leave_type_name,
                                        value: item.leave_type_id,
                                    }))
                                    : []
                            }
                            required
                        />
                    </div>

                    <div style={{marginBottom: "10px", display: "flex", flexDirection: "column"}}>
                        <label htmlFor="leave_from" style={{marginBottom: "5px"}}>
                            Leave Dates:
                        </label>
                        <RangePicker onChange={onRangeSet} format="YYYY-MM-DD"/>
                    </div>
                    <div style={{marginBottom: "10px"}}>
                        <label htmlFor="length" style={{marginBottom: "5px"}}>
                            Length:
                        </label>
                        <Select
                            id="length"
                            defaultValue={1}
                            value={leaveFormData.length}
                            onChange={(value) => {
                                handleInputChange({target: {id: "length", value}})
                            }
                            }
                            style={{width: "100%"}}
                            disabled={!halfDaySelection}
                            required
                        >
                            <Option value={1}>Full Day</Option>
                            <Option value={2}>First Half</Option>
                            <Option value={3}>Second Half</Option>
                        </Select>
                    </div>
                    <div style={{marginBottom: "10px"}}>
                        <label htmlFor="leave_reason" style={{marginBottom: "5px"}}>
                            Leave Reason:
                        </label>
                        <TextArea
                            id="leave_reason"
                            value={leaveFormData.leave_reason}
                            onChange={handleInputChange}
                            rows={3}
                            required
                            style={{width: "100%"}} // Adjust the width as needed
                        />
                    </div>
                    <div style={{marginBottom: "10px"}}>
                        <label htmlFor="cancel_meal_type" style={{marginBottom: "5px", color: "rgb(159, 108, 32)"}}>
                            Remember! Your ordered meals will cancel at the time you apply LEAVE.
                        </label>
                        <Radio.Group
                            id='cancel_meal_type'
                            defaultValue={"all"}
                            style={{
                                padding: "4px 0px",
                                border: "1px solid rgb(204 204 204 / 50%)",
                                borderRadius: "7px",
                                width: "100%",
                            }}
                        >
                            <Radio className='rd-meal-type' value="all" onClick={() => handleMealCancelation("all")}
                                   defaultChecked={true}>
                                All
                            </Radio>
                            <Radio className='rd-meal-type' value="breakfast"
                                   onClick={() => handleMealCancelation("breakfast")}>
                                Breakfast
                            </Radio>
                            <Radio className='rd-meal-type' value="lunch"
                                   onClick={() => handleMealCancelation("lunch")}>
                                Lunch
                            </Radio>
                            <Radio className='rd-meal-type' value="none"
                                   onClick={() => handleMealCancelation("none")}>
                                None
                            </Radio>
                        </Radio.Group>
                    </div>
                    {error && (
                        <div style={{color: "red", marginBottom: "10px"}}>{error}</div>
                    )}
                </Modal>
                <Modal
                    title="Weekly Leave Summary"
                    centered
                    open={weeklyModalVisible}
                    onOk={onWeeklyModalClose}
                    onCancel={onWeeklyModalClose}
                    cancelButtonProps={{style: {display: 'none'}}}
                    destroyOnClose={true}
                >
                    <div style={{marginBottom: "10px"}}>
                        <Table
                            columns={weeklyColumns}
                            pagination={false}
                            expandable={{
                                expandedRowRender: (record) => (
                                    <p
                                        style={{
                                            margin: 0,
                                        }}
                                    >
                                        {record.description}
                                    </p>
                                ),
                                rowExpandable: (record) => record.count !== 0,
                            }}
                            dataSource={weeklyData}
                        />
                    </div>

                </Modal>
                <div
                    style={{
                        margin: "40px 0px",
                        padding: "10px 0px",
                        display: "flex",
                        flexDirection: "column",
                        height: "100%",
                    }}
                >
                    <div className="list-title">All requested leaves</div>
                    <Table
                        columns={columns}
                        dataSource={leaveApplications}
                        pagination={tableParams.pagination}
                        onChange={onPageChange}
                        rowKey={(record) => record.leave_application_id}
                        rowClassName={(record, index) => index % 2 === 0 ? 'table-row-light' : 'table-row-dark'}
                    />
                </div>
            </div>
        </>
    );
};

export default LeaveTabLayout;
